<template>
  <CModal :visible="showModal" @close="() => { showModal = false }">
    <CModalHeader>
      <CModalTitle>Find In Map</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <CForm>
        <CFormInput
            type="text"
            label="Search A Place"
            placeholder="Search..."
            v-model="searchText"
            @keyup="handleKeyup"
            aria-describedby="exampleFormControlInputHelpInline"
        />
        <CFormSelect class="mt-3" v-if="options.length > 1" aria-label="Default select example" v-model="selectedPlace">
          <option v-for="(item, index) in options" :value="item.place_id" :key="index">{{ item.display_name }}</option>
        </CFormSelect>
      </CForm>

    </CModalBody>
    <CModalFooter>
      <CButton color="secondary" @click="() => { showModal = false }">
        Close
      </CButton>
      <CButton color="primary" @click="addMarkerFromFindPlace">Save changes</CButton>
    </CModalFooter>
  </CModal>

  <div class="map-page">
    <header class="map-header">
      <div class="map-header__bar">
        <div class="map-header__brand">
          <span class="map-header__logo" aria-hidden="true">◇</span>
          <span class="map-header__title">Harita</span>
        </div>

        <div class="map-header__pinned" aria-label="Sabit konum ve deprem kısayolları">
          <div class="map-header__pinned-row" aria-label="Konumlar">
            <button type="button" class="map-header__pin-btn" title="Yayladere" @click="goYayladere">
              Yayladere
            </button>
            <button type="button" class="map-header__pin-btn" title="Bingöl" @click="goBingol">
              Bingöl
            </button>
            <button type="button" class="map-header__pin-btn" title="Elazığ" @click="goElazig">
              Elazığ
            </button>
          </div>
          <span class="map-header__pinned-sep" aria-hidden="true"></span>
          <div class="map-header__pinned-row" aria-label="Deprem">
            <button
              type="button"
              class="map-header__pin-btn map-header__pin-btn--accent"
              title="Dünyadaki en son deprem"
              @click="goGlobalLastQuake"
            >
              Küresel son
            </button>
            <button
              type="button"
              class="map-header__pin-btn map-header__pin-btn--accent"
              title="Ülkendeki en son deprem"
              @click="goCountryLastQuake"
            >
              Ülke sonu
            </button>
            <button
              type="button"
              class="map-header__pin-btn"
              :class="{ 'map-header__pin-btn--active': last5 }"
              title="Son 5 deprem"
              @click="setQuakeMode5"
            >
              Son 5
            </button>
            <button
              type="button"
              class="map-header__pin-btn"
              :class="{ 'map-header__pin-btn--active': last24 }"
              title="Son 24 saat"
              @click="setQuakeMode24"
            >
              24 saat
            </button>
          </div>
        </div>

        <div
          v-if="toolbarFavoriteIds.length"
          class="map-header__favorites"
          aria-label="Hızlı erişim"
        >
          <button
            v-for="fid in toolbarFavoriteIds"
            :key="fid"
            type="button"
            class="map-header__fav-btn"
            :title="favoriteTitle(fid)"
            @click="runFavoriteAction(fid)"
          >
            {{ favoriteShortLabel(fid) }}
          </button>
        </div>

        <nav class="map-header__nav" aria-label="Harita menüleri">
          <div
            class="map-header__menu"
            :class="{ 'map-header__menu--raised': openDropdown === 'layers' }"
          >
            <button
              type="button"
              class="map-header__trigger"
              :class="{ 'map-header__trigger--open': openDropdown === 'layers' }"
              aria-haspopup="true"
              :aria-expanded="openDropdown === 'layers'"
              @click.stop="toggleDropdown('layers')"
            >
              Katmanlar
            </button>
            <div
              v-show="openDropdown === 'layers'"
              class="map-dropdown map-dropdown--wide"
              role="region"
              aria-label="Katman listesi"
              @click.stop
            >
              <p class="map-dropdown__hint">Göstermek istediğiniz katmanları işaretleyin. ★ ile hızlı erişime ekleyin.</p>
              <ul class="map-layer-list">
                <li
                  v-for="(layer, index) in availableLayers"
                  :key="'layer-' + index"
                  class="map-layer-list__item"
                >
                  <label class="map-layer-list__label">
                    <input
                      type="checkbox"
                      class="map-layer-list__check"
                      :checked="isLayerSelected(index)"
                      @change="toggleLayerSelect(index)"
                    />
                    <span class="map-layer-list__name">{{ layer.name }}</span>
                  </label>
                  <button
                    type="button"
                    class="map-fav-star"
                    :class="{ 'map-fav-star--on': isToolbarFavorite(layerFavoriteId(index)) }"
                    :title="isToolbarFavorite(layerFavoriteId(index)) ? 'Hızlı erişimden çıkar' : 'Hızlı erişime ekle'"
                    :aria-pressed="isToolbarFavorite(layerFavoriteId(index))"
                    @click.stop="toggleToolbarFavorite(layerFavoriteId(index))"
                  >
                    ★
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="map-header__menu"
            :class="{ 'map-header__menu--raised': openDropdown === 'locations' }"
          >
            <button
              type="button"
              class="map-header__trigger"
              :class="{ 'map-header__trigger--open': openDropdown === 'locations' }"
              aria-haspopup="true"
              :aria-expanded="openDropdown === 'locations'"
              @click.stop="toggleDropdown('locations')"
            >
              Konumlar
            </button>
            <div
              v-show="openDropdown === 'locations'"
              class="map-dropdown"
              role="region"
              aria-label="Kayıtlı konumlar"
              @click.stop
            >
              <ul class="map-dd-actions">
                <li class="map-dd-actions__row">
                  <button type="button" class="map-dd-actions__btn" @click="goYayladere(); closeDropdowns()">Yayladere</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('loc-yayladere') }" title="Favori" @click.stop="toggleToolbarFavorite('loc-yayladere')">★</button>
                </li>
                <li class="map-dd-actions__row">
                  <button type="button" class="map-dd-actions__btn" @click="goBingol(); closeDropdowns()">Bingöl</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('loc-b') }" @click.stop="toggleToolbarFavorite('loc-b')">★</button>
                </li>
                <li class="map-dd-actions__row">
                  <button type="button" class="map-dd-actions__btn" @click="goElazig(); closeDropdowns()">Elazığ</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('loc-m') }" @click.stop="toggleToolbarFavorite('loc-m')">★</button>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="map-header__menu map-header__menu--align-end"
            :class="{ 'map-header__menu--raised': openDropdown === 'quake' }"
          >
            <button
              type="button"
              class="map-header__trigger"
              :class="{ 'map-header__trigger--open': openDropdown === 'quake' }"
              aria-haspopup="true"
              :aria-expanded="openDropdown === 'quake'"
              @click.stop="toggleDropdown('quake')"
            >
              Deprem
            </button>
            <div
              v-show="openDropdown === 'quake'"
              class="map-dropdown"
              role="region"
              aria-label="Deprem araçları"
              @click.stop
            >
              <ul class="map-dd-actions">
                <li class="map-dd-actions__row">
                  <button type="button" class="map-dd-actions__btn map-dd-actions__btn--accent" @click="goGlobalLastQuake(); closeDropdowns()">Küresel son</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('qk-global') }" @click.stop="toggleToolbarFavorite('qk-global')">★</button>
                </li>
                <li class="map-dd-actions__row">
                  <button type="button" class="map-dd-actions__btn map-dd-actions__btn--accent" @click="goCountryLastQuake(); closeDropdowns()">Ülke sonu</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('qk-country') }" @click.stop="toggleToolbarFavorite('qk-country')">★</button>
                </li>
                <li class="map-dd-actions__row">
                  <button
                    type="button"
                    class="map-dd-actions__btn"
                    :class="{ 'map-dd-actions__btn--active': last5 }"
                    @click="setQuakeMode5(); closeDropdowns()"
                  >Son 5</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('qk-l5') }" @click.stop="toggleToolbarFavorite('qk-l5')">★</button>
                </li>
                <li class="map-dd-actions__row">
                  <button
                    type="button"
                    class="map-dd-actions__btn"
                    :class="{ 'map-dd-actions__btn--active': last24 }"
                    @click="setQuakeMode24(); closeDropdowns()"
                  >Son 24 saat</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('qk-l24') }" @click.stop="toggleToolbarFavorite('qk-l24')">★</button>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="map-header__menu map-header__menu--align-end"
            :class="{ 'map-header__menu--raised': openDropdown === 'tools' }"
          >
            <button
              type="button"
              class="map-header__trigger"
              :class="{ 'map-header__trigger--open': openDropdown === 'tools' }"
              aria-haspopup="true"
              :aria-expanded="openDropdown === 'tools'"
              @click.stop="toggleDropdown('tools')"
            >
              Araçlar
            </button>
            <div
              v-show="openDropdown === 'tools'"
              class="map-dropdown"
              role="region"
              aria-label="Araçlar"
              @click.stop
            >
              <ul class="map-dd-actions">
                <li class="map-dd-actions__row">
                  <button type="button" class="map-dd-actions__btn" @click="showModal = true; closeDropdowns()">Yer bul</button>
                  <button type="button" class="map-fav-star" :class="{ 'map-fav-star--on': isToolbarFavorite('tool-find') }" @click.stop="toggleToolbarFavorite('tool-find')">★</button>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div class="map-header__meta" aria-live="polite">
          <span class="map-header__zoom">z {{ zoomLevel }}</span>
        </div>
      </div>
    </header>

    <div class="map-body">
      <div ref="map-root" class="map-view-root">
        <div id="custom-controls"></div>
        <div
          id="popup"
          class="ol-popup"
          :class="{ 'ol-popup--quake': tooltipQuake }"
          v-show="tooltipQuake || tooltipPlain"
        >
          <div v-if="tooltipQuake" class="quake-tip">
            <div class="quake-tip__head">
              <span class="quake-tip__eyebrow">Deprem olayı</span>
              <span
                class="quake-tip__mag"
                :class="quakeMagnitudeClass(tooltipQuake.magnitude)"
              >M {{ formatMag(tooltipQuake.magnitude) }}</span>
            </div>
            <p class="quake-tip__place">{{ tooltipQuake.place || '—' }}</p>
            <dl class="quake-tip__grid">
              <div class="quake-tip__row">
                <dt>Zaman</dt>
                <dd>{{ formatQuakeTime(tooltipQuake.time) }}</dd>
              </div>
              <div class="quake-tip__row">
                <dt>Derinlik</dt>
                <dd>{{ formatQuakeDepth(tooltipQuake.depth) }}</dd>
              </div>
            </dl>
          </div>
          <div v-else-if="tooltipPlain" id="popup-content" class="ol-popup__plain">{{ tooltipPlain }}</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import '@coreui/coreui/dist/css/coreui.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import { useGeographic } from 'ol/proj'
import WMS from 'ol/source/TileWMS'
import XYZ from 'ol/source/XYZ'


import ApiService from "@/core/ApiService"
/** Yerel ülke kutuları (sandstrom/country-bounding-boxes, MIT) — ağ çağrısı yok */
import countryBoundingBoxes from '@/data/countryBoundingBoxes.json'
import { Feature, Overlay } from "ol"
import { defaults as defaultControls, ScaleLine, Zoom } from 'ol/control'
import GeoJSON from 'ol/format/GeoJSON'
import * as geom from "ol/geom"
import VectorLayer from "ol/layer/Vector"
import VectorSource from "ol/source/Vector"
import * as style from "ol/style"
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style"

import {
  CButton,
  CForm,
  CFormInput,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle
} from '@coreui/vue'


export default {
  name: 'MapContainer',
  components: {CFormSelect, CFormInput, CForm, CButton, CModalFooter, CModalBody, CModalTitle, CModalHeader, CModal},
  props: {},
  data() {
    return {
      loadingPlace: false,
      selectedPlace: null,
      searchText: '',
      debounceTimer: null,
      options: [],
      showModal: false,
      /** Deprem dairesi tooltip (yapılandırılmış) */
      tooltipQuake: null,
      /** Diğer özellikler için düz metin */
      tooltipPlain: null,
      last24: true,
      last5: false,
      latitude: 35.79098358945339,
      longitude: 39.17110064016026,
      accuracy: 0,
      defaultZoom: 7,
      map: null,
      markers: [],
      circles: [],
      lastQuake: [],
      lastQuakeGroup: null,
      /** Harita/GPS konumuna göre yerel veri setinden ülke kutusu (°) */
      userCountryBbox: null,
      /** [lon, lat] — ülke içi son deprem; Local Last butonu */
      lastQuakeCountryCoordinates: null,
      circleGroup: null,
      disableZoom: false,
      markerGroup: null,
      openDropdown: null,
      toolbarFavoriteIds: [],
      zoomLevel: 7,
      _mapToolbarDocClick: null,
      _mapToolbarKeydown: null,
      selectedLayers: [],
      availableLayers: [
        {
          name: 'Google Map', source: new TileLayer({
            source: new XYZ({
              url: 'https://mt0.google.com/vt/lyrs=m&hl=tr&x={x}&y={y}&z={z}',
            }),
            zIndex: 0,
            transparent: true,
          })
        },
        {
          name: 'Google Map Satellite',
          source: new TileLayer({
            source: new XYZ({
              url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
            }),
            zIndex: 0,
            transparent: true,
          })
        },
        {
          name: 'Deprem Risk Haritası', source: new TileLayer({
            source: new WMS({
              url: 'https://efehrmaps.ethz.ch/cgi-bin/mapserv?MAP=/var/www/mapfile/sharehazard.01.map',
              params: {
                'LAYERS': 'hmap975',
                'TRANSPARENT': 'TRUE',
                'FORMAT': 'image/png',
                'VERSION': '1.1.1',
              },
              serverType: 'mapserver',
              attributions: '© EFEHR / GSHAP – Küresel sismik tehlike (PGA, %10 / 50 yıl)',
            }),
            opacity: 0.72,
            zIndex: 2,
          })
        },
        {
          name: 'Fay Hattı 1', source: new VectorLayer({
            source: new VectorSource({
              url: 'https://cdn.jsdelivr.net/gh/GEMScienceTools/gem-global-active-faults@master/geojson/gem_active_faults.geojson',
              format: new GeoJSON(),
              attributions: '© GEM Global Active Faults (CC BY-SA 4.0)',
            }),
            style: new Style({
              stroke: new Stroke({
                color: 'rgba(185, 35, 25, 0.9)',
                width: 1.35,
              }),
            }),
            zIndex: 3,
          })
        },
        {
          name: 'Fay Hattı 2', source: new TileLayer({
            source: new XYZ({
              url: 'https://earthquake.usgs.gov/arcgis/rest/services/eq/map_plateboundaries/MapServer/tile/{z}/{y}/{x}',
              projection: 'EPSG:3857',
              crossOrigin: 'anonymous',
              maxZoom: 23,
              transition: 0,
              attributions: '© USGS – tektonik levha sınırları (Bird 2003)',
            }),
            opacity: 0.95,
            zIndex: 4,
          })
        },
        {
          name: 'Bölgeler',
          source: new TileLayer({
            source: new XYZ({
              url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
              attributions: 'Esri, HERE, Garmin, © OpenStreetMap contributors',
            }),
            transparent: true,
            zIndex: 4
          }),
        },
        {
          name: 'Bulutlar', source: new TileLayer({
            source: new XYZ({
              url: 'https://tile.openweathermap.org/map/clouds_new/{z}/{x}/{y}.png?appid=d3b46c07b4afd18734fc52d07159b5bc',
            }),
            format: 'image/png',
            transparent: true,
            zIndex: 5
          })
        },
        {
          name: 'Yağış', source: new TileLayer({
            source: new XYZ({
              url: 'https://tile.openweathermap.org/map/precipitation_new/{z}/{x}/{y}.png?appid=d3b46c07b4afd18734fc52d07159b5bc',
            }),
            format: 'image/png',
            transparent: true,
            zIndex: 5
          })
        },
        {
          name: 'Deniz seviyesi basıncı', source: new TileLayer({
            source: new XYZ({
              url: 'https://tile.openweathermap.org/map/pressure_new/{z}/{x}/{y}.png?appid=d3b46c07b4afd18734fc52d07159b5bc',
            }),
            format: 'image/png',
            transparent: true,
            zIndex: 5
          })
        },
        {
          name: 'Rüzgar hızı', source: new TileLayer({
            source: new XYZ({
              url: 'https://tile.openweathermap.org/map/wind_new/{z}/{x}/{y}.png?appid=d3b46c07b4afd18734fc52d07159b5bc',
            }),
            format: 'image/png',
            transparent: true,
            zIndex: 5
          })
        },
        {
          name: 'Sıcaklık', source: new TileLayer({
            source: new XYZ({
              url: 'https://tile.openweathermap.org/map/temp_new/{z}/{x}/{y}.png?appid=d3b46c07b4afd18734fc52d07159b5bc',
            }),
            format: 'image/png',
            transparent: true,
            zIndex: 5
          })
        },
      ],
      layers: [],
      circleStyle: new Style({
        image: new CircleStyle({
          radius: 10,
          fill: new Fill({
            color: "rgba(255, 0, 0, 0.5)",
          }),
        }),
      })
    }
  },
  mounted() {
    useGeographic();

    this.selectedLayers = this.getSelectedLayers()
    this.loadToolbarFavorites()
    this.zoomLevel = Number(this.defaultZoom)

    this.map = new Map({
      controls: defaultControls({ attribution: false }).extend([
        new Zoom(),
        new ScaleLine(),
      ]),
      // the map will be created using the 'map-root' ref
      target: this.$refs['map-root'],
      layers: this.getSelectedLayers().length > 0 ? this.getSelectedLayers().map((item) => this.availableLayers[item].source) : this.availableLayers.filter((item, index) => {
        return index !== 1 && index < 8
      }).map((item) => {
        return item.source
      }),

      // the map view will initially show the whole world
      view: new View({
        zoom: this.defaultZoom,
        center: [this.latitude, this.longitude],
        // constrainResolution: true,
        smoothResolutionConstraint: false,
        // zoomFactor: 5
      }),
    })

    self = this;

    this.zoomLevel = this.map.getView().getZoom().toFixed(2)

    this.popup = new Overlay({
      element: document.getElementById('popup'),
      /* Hover'da her pointermove + setPosition autoPan haritayı iter; kapatıldı. */
      autoPan: false,
    });

    this.map.addOverlay(this.popup);

    this.map.on("moveend", function (e) {
      self.latitude = self.map.getView().getCenter()[0];
      self.longitude = self.map.getView().getCenter()[1];
      self.defaultZoom = self.map.getView().getZoom();
    })

    this.map.getView().on('change:resolution', () => {
      this.zoomLevel = this.map.getView().getZoom().toFixed(2)
    })

    this._mapToolbarDocClick = (e) => {
      const header = this.$el?.querySelector?.('.map-header')
      if (header && !header.contains(e.target)) {
        this.openDropdown = null
      }
    }
    this._mapToolbarKeydown = (e) => {
      if (e.key === 'Escape') this.openDropdown = null
    }
    document.addEventListener('click', this._mapToolbarDocClick)
    document.addEventListener('keydown', this._mapToolbarKeydown)

    this.map.on('click', function (evt) {
      self.showTooltip(evt);
    });
    this.map.on('pointermove', function (evt) {
      self.showTooltip(evt);
    });

    this.initialize();

    this.applyUserCountryBboxFromMapCenter()
    this.refreshQuakeLayersIfActive()

    setTimeout(this.getLast24, 100)
    setInterval(this.getLast24, 10000);

    setTimeout(this.getLast5, 100)
    setInterval(this.getLast5, 10000);

  },

  beforeUnmount() {
    if (this._mapToolbarDocClick) {
      document.removeEventListener('click', this._mapToolbarDocClick)
    }
    if (this._mapToolbarKeydown) {
      document.removeEventListener('keydown', this._mapToolbarKeydown)
    }
  },

  methods: {
    loadToolbarFavorites() {
      try {
        const raw = localStorage.getItem('mapToolbarFavorites')
        const parsed = raw ? JSON.parse(raw) : []
        this.toolbarFavoriteIds = Array.isArray(parsed) ? parsed : []
      } catch {
        this.toolbarFavoriteIds = []
      }
    },
    saveToolbarFavorites() {
      localStorage.setItem(
        'mapToolbarFavorites',
        JSON.stringify(this.toolbarFavoriteIds)
      )
    },
    layerFavoriteId(index) {
      return `layer-${index}`
    },
    isToolbarFavorite(id) {
      return this.toolbarFavoriteIds.includes(id)
    },
    toggleToolbarFavorite(id) {
      const max = 16
      let next = [...this.toolbarFavoriteIds]
      const i = next.indexOf(id)
      if (i >= 0) {
        next.splice(i, 1)
      } else {
        if (next.length >= max) next.pop()
        next.unshift(id)
      }
      this.toolbarFavoriteIds = next
      this.saveToolbarFavorites()
    },
    favoriteTitle(id) {
      if (id.startsWith('layer-')) {
        const idx = parseInt(id.replace('layer-', ''), 10)
        return this.availableLayers[idx]?.name || id
      }
      const titles = {
        'loc-yayladere': 'Yayladere',
        'loc-b': 'Bingöl',
        'loc-m': 'Elazığ',
        'qk-global': 'Küresel son deprem',
        'qk-country': 'Ülke son deprem',
        'qk-l5': 'Son 5 deprem',
        'qk-l24': 'Son 24 saat',
        'tool-find': 'Yer bul',
      }
      return titles[id] || id
    },
    favoriteShortLabel(id) {
      if (id.startsWith('layer-')) {
        const idx = parseInt(id.replace('layer-', ''), 10)
        const n = this.availableLayers[idx]?.name || '?'
        return n.length > 10 ? n.slice(0, 9) + '…' : n
      }
      const short = {
        'loc-yayladere': 'Yayladere',
        'loc-b': 'Bingöl',
        'loc-m': 'Elazığ',
        'qk-global': 'Küresel',
        'qk-country': 'Ülke',
        'qk-l5': '5',
        'qk-l24': '24s',
        'tool-find': 'Ara',
      }
      return short[id] || id
    },
    runFavoriteAction(id) {
      if (id.startsWith('layer-')) {
        const idx = parseInt(id.replace('layer-', ''), 10)
        if (!Number.isNaN(idx)) this.toggleLayerSelect(idx)
        return
      }
      switch (id) {
        case 'loc-yayladere':
          this.goYayladere()
          break
        case 'loc-b':
          this.goBingol()
          break
        case 'loc-m':
          this.goElazig()
          break
        case 'qk-global':
          this.goGlobalLastQuake()
          break
        case 'qk-country':
          this.goCountryLastQuake()
          break
        case 'qk-l5':
          this.setQuakeMode5()
          break
        case 'qk-l24':
          this.setQuakeMode24()
          break
        case 'tool-find':
          this.showModal = true
          break
      }
    },
    toggleDropdown(name) {
      this.openDropdown = this.openDropdown === name ? null : name
    },
    closeDropdowns() {
      this.openDropdown = null
    },
    isLayerSelected(index) {
      const n = Number(index)
      return this.selectedLayers.map(Number).includes(n)
    },
    toggleLayerSelect(index) {
      const idx = Number(index)
      const layers = this.selectedLayers.map(Number)
      const i = layers.indexOf(idx)
      if (i >= 0) {
        this.selectedLayers = layers.filter((_, j) => j !== i)
      } else {
        this.selectedLayers = [...layers, idx].sort((a, b) => a - b)
      }
      this.changeLayers()
    },
    goYayladere() {
      if (!this.map) return
      this.map.getView().setCenter([40.0691993, 39.2262618])
    },
    goBingol() {
      if (!this.map) return
      this.map.getView().setCenter([40.498, 38.885])
    },
    goElazig() {
      if (!this.map) return
      this.map.getView().setCenter([39.223, 38.681])
    },
    goGlobalLastQuake() {
      if (!this.map) return
      const c = this.lastQuakeCoordinates
      if (c && c.length === 2) this.map.getView().setCenter(c)
    },
    goCountryLastQuake() {
      if (!this.map) return
      const c = this.lastQuakeCountryCoordinates
      if (c && c.length === 2) this.map.getView().setCenter(c)
    },
    setQuakeMode5() {
      this.last5 = true
      this.last24 = false
    },
    setQuakeMode24() {
      this.last24 = true
      this.last5 = false
    },
    getSelectedLayers() {
      return localStorage.getItem('selectedLayers') && JSON.parse(localStorage.getItem("selectedLayers")).length > 0 ? JSON.parse(localStorage.getItem('selectedLayers')) : []
    },
    initialize() {
      this.addMarkerGroup([40.498, 38.885])
      this.addMarkerGroup([39.223, 38.681])
      this.addMarkerGroup([40.0691993, 39.2262618])
      this.addMarkerGroup([39.7478168, 38.978196])

      navigator.geolocation.getCurrentPosition(function (location) {
        self.latitude = location.coords.latitude;
        self.longitude = location.coords.longitude;
        self.accuracy = location.coords.accuracy;
        self.addMarkerGroup([self.longitude, self.latitude])
        self.map.getView().setCenter([self.longitude, self.latitude])
        self.applyUserCountryBboxFromLatLon(
          location.coords.latitude,
          location.coords.longitude
        )
        self.refreshQuakeLayersIfActive()
      });

    },
    changeLayers() {
      this.map.getLayers().forEach(layer => {
        this.map.removeLayer(layer)
      })

      let layerList = []

      if (this.selectedLayers.length > 0) {
        for (let i = 0; i < this.selectedLayers.length; i++) {
          layerList.push(this.availableLayers[this.selectedLayers[i]].source)
        }
      } else {
        layerList.push(this.availableLayers[0].source)
      }

      localStorage.setItem('selectedLayers', JSON.stringify(this.selectedLayers))

      this.map.setLayers(layerList)

      this.markerGroup.getSource().clear();
      this.map.removeLayer(this.markerGroup);
      this.initialize();
    },

    addMarkerFromFindPlace() {
      if (!this.selectedPlace) {
        return false;
      }


      const selectedPlace = this.options.find((item) => {
        return item.place_id === parseInt(this.selectedPlace)
      })

      this.addMarkerGroup([selectedPlace.lon, selectedPlace.lat])
      this.map.getView().setCenter([selectedPlace.lon, selectedPlace.lat])
      this.options = [{display_name: 'Loading...', place_id: ''}];
      this.searchText = ''
      this.showModal = false;
    },
    handleKeyup() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.getOptions()
      }, 500);
    },
    getOptions() {
      this.selectedPlace = null;
      this.options = [{display_name: 'Loading...', place_id: ''}];
      ApiService.get("https://nominatim.openstreetmap.org/search?q=" + this.searchText + "&format=json").then((response) => {
        this.options = [{display_name: 'Select', place_id: ''}, ...response.data];
      });
    },

    showTooltip(evt) {
      const feature = self.map.forEachFeatureAtPixel(evt.pixel, function (feat) {
        return feat
      })

      if (feature) {
        const coordinate = evt.coordinate
        const tip = feature.get('quakeTip')
        if (tip && typeof tip === 'object') {
          self.tooltipQuake = { ...tip }
          self.tooltipPlain = null
          self.popup.setPosition(coordinate)
          return
        }
        const desc = feature.get('desc')
        if (desc && String(desc) !== 'undefined') {
          self.tooltipQuake = null
          self.tooltipPlain = String(desc)
          self.popup.setPosition(coordinate)
          return
        }
      }
      self.tooltipQuake = null
      self.tooltipPlain = null
      self.popup.setPosition(undefined)
    },

    formatMag(m) {
      const n = Number(m)
      return Number.isFinite(n) ? n.toFixed(1) : (m ?? '—')
    },

    formatQuakeTime(iso) {
      if (!iso) return '—'
      try {
        return new Intl.DateTimeFormat('tr-TR', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }).format(new Date(iso))
      } catch {
        return String(iso)
      }
    },

    formatQuakeDepth(d) {
      if (d === '' || d == null) return '—'
      const n = Number(d)
      if (Number.isFinite(n)) return `${n} km`
      return `${d} km`
    },

    quakeMagnitudeClass(m) {
      const x = Number(m)
      if (!Number.isFinite(x)) return ''
      if (x < 4) return 'quake-tip__mag--low'
      if (x < 5.5) return 'quake-tip__mag--mid'
      return 'quake-tip__mag--high'
    },
    addMarkerGroup(coordinate) {
      this.map.removeLayer(this.markerGroup);
      let marker = new Feature({
        geometry: new geom.Point(coordinate),
      });
      marker.setStyle(
          new Style({
            image: new style.Icon({
              src: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
            }),
          })
      );

      this.markers.push(marker);

      let vectorSource = new VectorSource({
        features: this.markers,
      });
      this.markerGroup = new VectorLayer({
        source: vectorSource,
        zIndex: 6
      });
      this.map.addLayer(this.markerGroup);
    },

    /**
     * Küresel son deprem: kırmızı halkalar; ülke sonu: mavi (aynı noktada tekrar çizilmez).
     * @param {number[]} globalCoord [lon, lat]
     * @param {number[]|null} countryCoord [lon, lat] | null
     */
    addLastQuake(globalCoord, countryCoord = null) {
      this.lastQuake = [];
      if (this.lastQuakeGroup) {
        this.map.removeLayer(this.lastQuakeGroup);
      }

      const baseRadius = 1;
      const numberOfCircles = 5;
      const gapBetweenCircles = 5;
      const innerCircleRadii = Array.from(
        { length: numberOfCircles },
        (_, index) => baseRadius * (index + 2) + gapBetweenCircles * index
      );

      const appendRings = (coordinate, strokeMain) => {
        innerCircleRadii.forEach((radius) => {
          this.lastQuake.push(
            this.getCircleMarker(coordinate, radius - 1, 'rgba(255,255,255)', 1)
          );
          this.lastQuake.push(
            this.getCircleMarker(coordinate, radius, strokeMain, 3)
          );
          this.lastQuake.push(
            this.getCircleMarker(coordinate, radius + 1, 'rgba(255,255,255)', 1)
          );
        });
      };

      appendRings(globalCoord, 'rgba(255,0,0)');

      const samePoint =
        countryCoord &&
        Math.abs(globalCoord[0] - countryCoord[0]) < 0.02 &&
        Math.abs(globalCoord[1] - countryCoord[1]) < 0.02;
      if (countryCoord && !samePoint) {
        appendRings(countryCoord, 'rgba(255,0,0)');
      }

      let vectorSource = new VectorSource({
        features: this.lastQuake,
      });
      this.lastQuakeGroup = new VectorLayer({
        source: vectorSource,
        zIndex: 7,
      });

      this.map.addLayer(this.lastQuakeGroup);
    },

    refreshQuakeLayersIfActive() {
      if (this.last24) this.getLast24();
      else if (this.last5) this.getLast5();
    },

    /**
     * Açılış / harita merkezi [lon, lat] ile ülke kutusu (yalnızca bundle içi JSON).
     */
    applyUserCountryBboxFromMapCenter() {
      if (!this.map) return
      const c = this.map.getView().getCenter()
      this.applyUserCountryBboxFromLatLon(c[1], c[0])
    },

    /**
     * lat/lon hangi ülke kutusuna düşüyorsa onu seçer; birden fazlaysa en küçük alanlı kutu (sınır yakını).
     */
    applyUserCountryBboxFromLatLon(lat, lon) {
      if (
        lat == null ||
        lon == null ||
        Number.isNaN(lat) ||
        Number.isNaN(lon)
      ) {
        this.userCountryBbox = null
        return
      }
      const matches = []
      for (const entry of Object.values(countryBoundingBoxes)) {
        const box = entry[1]
        const west = box[0]
        const south = box[1]
        const east = box[2]
        const north = box[3]
        if (lon >= west && lon <= east && lat >= south && lat <= north) {
          const area = (east - west) * (north - south)
          matches.push({ west, south, east, north, area })
        }
      }
      if (!matches.length) {
        this.userCountryBbox = null
        return
      }
      matches.sort((a, b) => a.area - b.area)
      const b = matches[0]
      this.userCountryBbox = {
        south: b.south,
        north: b.north,
        west: b.west,
        east: b.east,
      }
    },

    /** Zamana göre azalan sıralı listede, kullanıcı ülkesi içindeki en yeni deprem */
    pickLatestQuakeInUserCountry(sortedByTimeDesc) {
      const box = this.userCountryBbox;
      if (!box || !sortedByTimeDesc.length) return null;
      const { south, north, west, east } = box;
      for (let i = 0; i < sortedByTimeDesc.length; i++) {
        const e = sortedByTimeDesc[i];
        const lon = e.longitude;
        const lat = e.latitude;
        if (lon >= west && lon <= east && lat >= south && lat <= north) {
          return [lon, lat];
        }
      }
      return null;
    },

    getCircleMarker(coordinate, radius, color, width) {
      const marker = new Feature({
        geometry: new geom.Point(coordinate),
      });

      const innerCircleStyle = new Style({
        image: new CircleStyle({
          radius: radius - 1,
          stroke: new style.Stroke({
            color: color,
            width: width,
          }),
        }),
      });

      marker.setStyle(innerCircleStyle)
      return marker;
    },

    addButton(text, handler) {
      let button = document.createElement('button');
      button.innerHTML = text;
      button.addEventListener('click', handler, false);
      button.addEventListener('touchstart', handler, false);
      let element = document.createElement('div');
      element.className = 'ol-unselectable ol-control';
      element.appendChild(button);
      return element;
    },

    /** USGS GeoJSON / FDSN → mevcut { latitude, longitude, magnitude, ... } biçimi */
    parseUsgsEarthquakeFeatures(data) {
      const features = data && Array.isArray(data.features) ? data.features : []
      return features.map((f) => {
        const t = f.properties.time
        const timeMs =
          typeof t === 'number'
            ? t
            : t
              ? new Date(t).getTime()
              : 0
        return {
          longitude: f.geometry.coordinates[0],
          latitude: f.geometry.coordinates[1],
          depth:
            f.geometry.coordinates[2] != null
              ? f.geometry.coordinates[2]
              : (f.properties.depth != null ? f.properties.depth : ''),
          magnitude: f.properties.mag,
          location: f.properties.place || f.properties.title || '',
          eventDate: t
            ? new Date(typeof t === 'number' ? t : t).toISOString()
            : '',
          timeMs,
        }
      })
    },

    /** EMSC seismicportal FDSN JSON (format=json) — USGS ile aynı alanlar */
    parseEmscEarthquakeFeatures(data) {
      const features = data && Array.isArray(data.features) ? data.features : []
      return features.map((f) => {
        const p = f.properties || {}
        const lon = f.geometry.coordinates[0]
        const lat = f.geometry.coordinates[1]
        const t = p.time
        const timeMs = t ? new Date(t).getTime() : 0
        return {
          longitude: lon,
          latitude: lat,
          depth:
            f.geometry.coordinates[2] != null
              ? f.geometry.coordinates[2]
              : (p.depth != null ? p.depth : ''),
          magnitude: p.mag,
          location: p.flynn_region || p.auth || '',
          eventDate: t ? new Date(t).toISOString() : '',
          timeMs,
        }
      })
    },

    isDuplicateEarthquake(a, b) {
      if (Math.abs((a.timeMs || 0) - (b.timeMs || 0)) > 120000) return false
      const dlat = (a.latitude - b.latitude) * 111
      const dlon =
        (a.longitude - b.longitude) *
        111 *
        Math.cos((a.latitude * Math.PI) / 180)
      return Math.hypot(dlat, dlon) < 50
    },

    mergeEarthquakeLists(primary, secondary) {
      const out = [...primary]
      for (const e of secondary) {
        if (!out.some((o) => this.isDuplicateEarthquake(o, e))) out.push(e)
      }
      return out
    },

    sortQuakesByMagnitudeDesc(list) {
      return [...list].sort(
        (a, b) => (Number(b.magnitude) || 0) - (Number(a.magnitude) || 0)
      )
    },

    /**
     * Son 24 saat: USGS M1.0+ (1 gün feed) + EMSC Türkiye kutusu; son deprem zamana göre, daireler büyüklüğe göre.
     */
    getLast24() {
      if (!this.last24) return
      const usgsUrl =
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/1.0_day.geojson'
      const end = new Date()
      const start = new Date(end.getTime() - 86400000)
      const emscUrl =
        'https://www.seismicportal.eu/fdsnws/event/1/query?format=json&starttime=' +
        encodeURIComponent(start.toISOString()) +
        '&endtime=' +
        encodeURIComponent(end.toISOString()) +
        '&minlatitude=35.8&maxlatitude=42.5&minlongitude=25.5&maxlongitude=46&orderby=time&limit=400'

      Promise.allSettled([ApiService.get(usgsUrl), ApiService.get(emscUrl)])
        .then((results) => {
          let usgs = []
          if (results[0].status === 'fulfilled') {
            usgs = this.parseUsgsEarthquakeFeatures(results[0].value.data)
          }
          let emsc = []
          if (results[1].status === 'fulfilled') {
            emsc = this.parseEmscEarthquakeFeatures(results[1].value.data)
          }
          let parameters = this.mergeEarthquakeLists(usgs, emsc)
          if (!parameters.length) return
          parameters.sort((a, b) => (b.timeMs || 0) - (a.timeMs || 0))
          this.lastQuakeCoordinates = [
            parameters[0].longitude,
            parameters[0].latitude,
          ]
          const countryCoord = this.pickLatestQuakeInUserCountry(parameters)
          this.lastQuakeCountryCoordinates = countryCoord
          this.addLastQuake(this.lastQuakeCoordinates, countryCoord)
          this.addCircle(this.sortQuakesByMagnitudeDesc(parameters))
        })
        .catch(() => {})
    },

    /**
     * Son 5: USGS FDSN (yeterince geniş havuz) + EMSC Türkiye (24 saat); birleşik listede zamana göre en yeni 5; merkez [0], daireler büyüklüğe göre.
     */
    getLast5() {
      if (!this.last5) return
      const end = new Date()
      const start = new Date(end.getTime() - 86400000)
      const usgsUrl =
        'https://earthquake.usgs.gov/fdsnws/event/1/query?format=geojson&limit=50&orderby=time&minmagnitude=2.5'
      const emscUrl =
        'https://www.seismicportal.eu/fdsnws/event/1/query?format=json&starttime=' +
        encodeURIComponent(start.toISOString()) +
        '&endtime=' +
        encodeURIComponent(end.toISOString()) +
        '&minlatitude=35.8&maxlatitude=42.5&minlongitude=25.5&maxlongitude=46&orderby=time&limit=400'

      Promise.allSettled([ApiService.get(usgsUrl), ApiService.get(emscUrl)])
        .then((results) => {
          let usgs = []
          if (results[0].status === 'fulfilled') {
            usgs = this.parseUsgsEarthquakeFeatures(results[0].value.data)
          }
          let emsc = []
          if (results[1].status === 'fulfilled') {
            emsc = this.parseEmscEarthquakeFeatures(results[1].value.data)
          }
          let merged = this.mergeEarthquakeLists(usgs, emsc)
          if (!merged.length) return
          merged.sort((a, b) => (b.timeMs || 0) - (a.timeMs || 0))
          const parameters = merged.slice(0, 5)
          this.lastQuakeCoordinates = [
            merged[0].longitude,
            merged[0].latitude,
          ]
          const countryCoord = this.pickLatestQuakeInUserCountry(merged)
          this.lastQuakeCountryCoordinates = countryCoord
          this.addLastQuake(this.lastQuakeCoordinates, countryCoord)
          this.addCircle(this.sortQuakesByMagnitudeDesc(parameters))
        })
        .catch(() => {})
    },

    addCircle(data) {
      this.map.removeLayer(this.circleGroup);
      this.circles = [];

      let lastLat = data[0].latitude
      let lastLong = data[0].longitude

      data.map((item) => {
        let circle = new Feature({
          geometry: new geom.Circle([item.longitude, item.latitude], (Math.exp(item.magnitude / 1.01 - 0.33)) / (100)),
          quakeTip: {
            magnitude: item.magnitude,
            time: item.eventDate,
            depth: item.depth,
            place: item.location,
          },
          desc: item.magnitude + "\n" + this.getDate(item.eventDate) + "\n" + item.depth + "\n" + item.location,
        });

        const circleStyle = new Style({
          stroke: new style.Stroke({
            color: '#41ff00',
            width: 1,
          }),
          fill: new style.Fill({
            color: 'rgba(0,0,0,0.4)',
          }),
        });
        circle.setStyle(circleStyle);

        this.circles.push(circle);
      })

      let vectorSource = new VectorSource({
        features: this.circles,
      });
      this.circleGroup = new VectorLayer({
        source: vectorSource,
        zIndex: 5
      });
      this.map.addLayer(this.circleGroup);
    },

    getDate(strDate) {
      return strDate
    },
  }
}
</script>

<style>
.map-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  box-sizing: border-box;
  background: #0f172a;
}

.map-body {
  flex: 1;
  min-height: 0;
  position: relative;
}

/* Üst menü — haritanın üzerinde, açılır paneller z-index ile haritaya doğru */
.map-header {
  position: relative;
  z-index: 1100;
  flex-shrink: 0;
  overflow: visible;
  background: rgba(15, 23, 42, 0.97);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}

.map-header__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  padding: 8px 12px;
  min-height: 44px;
  overflow: visible;
}

.map-header__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e2e8f0;
  font-weight: 700;
  font-size: 15px;
}

.map-header__logo {
  color: #38bdf8;
  font-size: 18px;
}

.map-header__title {
  letter-spacing: -0.02em;
}

/* Konumlar + Deprem: dropdown ile aynı işlev, sabit sol şerit */
.map-header__pinned {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  max-width: min(100%, 720px);
}

.map-header__pinned-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
}

.map-header__pinned-sep {
  width: 1px;
  height: 22px;
  background: rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
}

.map-header__pin-btn {
  margin: 0;
  padding: 5px 9px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.07);
  color: #e2e8f0;
  cursor: pointer;
  white-space: nowrap;
}

.map-header__pin-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.22);
}

.map-header__pin-btn:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.map-header__pin-btn--accent {
  background: rgba(185, 28, 28, 0.28);
  border-color: rgba(248, 113, 113, 0.35);
  color: #fecaca;
}

.map-header__pin-btn--accent:hover {
  background: rgba(185, 28, 28, 0.42);
  color: #fff;
}

.map-header__pin-btn--active {
  background: rgba(56, 189, 248, 0.28);
  border-color: rgba(56, 189, 248, 0.5);
  color: #e0f2fe;
}

.map-header__favorites {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
  max-width: min(100%, 420px);
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  padding: 2px 0;
}

.map-header__fav-btn {
  flex: 0 0 auto;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid rgba(56, 189, 248, 0.35);
  background: rgba(56, 189, 248, 0.12);
  color: #e0f2fe;
  cursor: pointer;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-header__fav-btn:hover {
  background: rgba(56, 189, 248, 0.22);
  border-color: rgba(56, 189, 248, 0.5);
}

.map-header__fav-btn:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.map-header__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px;
  flex: 1 1 auto;
  justify-content: flex-end;
}

/* Her menü kendi tetikleyicisinin altında açılır */
.map-header__menu {
  position: relative;
  z-index: 1;
}

.map-header__menu--raised {
  z-index: 40;
}

.map-header__menu--align-end .map-dropdown {
  left: auto;
  right: 0;
}

.map-header__trigger {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: #cbd5e1;
  cursor: pointer;
  white-space: nowrap;
}

.map-header__trigger:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f1f5f9;
}

.map-header__trigger--open {
  background: rgba(56, 189, 248, 0.2);
  border-color: rgba(56, 189, 248, 0.45);
  color: #f0f9ff;
}

.map-header__meta {
  flex: 0 0 auto;
}

.map-header__zoom {
  font-family: ui-monospace, monospace;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  padding: 6px 10px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.map-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 1200;
  margin: 0;
  width: max-content;
  min-width: 220px;
  max-height: min(55vh, 360px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: rgba(30, 41, 59, 0.98);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow:
    0 16px 48px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(0, 0, 0, 0.2);
  padding: 10px 12px 12px;
}

.map-dropdown--wide {
  min-width: min(300px, calc(100vw - 24px));
  max-width: min(420px, calc(100vw - 16px));
}

.map-dropdown:not(.map-dropdown--wide) {
  max-width: min(300px, calc(100vw - 16px));
}

.map-dropdown__hint {
  margin: 0 0 10px;
  font-size: 11px;
  line-height: 1.4;
  color: #94a3b8;
}

.map-layer-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.map-layer-list__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.map-layer-list__item:last-child {
  border-bottom: none;
}

.map-layer-list__label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  cursor: pointer;
  color: #e2e8f0;
  font-size: 12px;
  text-align: left;
}

.map-layer-list__check {
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: #38bdf8;
}

.map-layer-list__name {
  line-height: 1.35;
}

.map-dd-actions {
  list-style: none;
  margin: 0;
  padding: 0;
}

.map-dd-actions__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.map-dd-actions__row:last-child {
  margin-bottom: 0;
}

.map-dd-actions__btn {
  flex: 1;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.08);
  color: #f1f5f9;
  cursor: pointer;
}

.map-dd-actions__btn:hover {
  background: rgba(255, 255, 255, 0.14);
}

.map-dd-actions__btn--accent {
  background: rgba(185, 28, 28, 0.35);
  border-color: rgba(248, 113, 113, 0.35);
  color: #fecaca;
}

.map-dd-actions__btn--accent:hover {
  background: rgba(185, 28, 28, 0.5);
}

.map-dd-actions__btn--active {
  background: rgba(56, 189, 248, 0.25);
  border-color: rgba(56, 189, 248, 0.45);
  color: #e0f2fe;
}

.map-fav-star {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  padding: 0;
  font-size: 16px;
  line-height: 1;
  border: none;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  color: #64748b;
  cursor: pointer;
}

.map-fav-star:hover {
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.12);
}

.map-fav-star--on {
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.15);
}

/* Harita alanı */
.map-view-root {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* Özellik balonu — üst çubukla uyumlu koyu kart */
.ol-popup {
  position: absolute;
  bottom: 12px;
  left: -56px;
  min-width: 200px;
  max-width: min(300px, calc(100vw - 24px));
  padding: 0;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.96);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  line-height: 1.45;
  color: #e2e8f0;
  overflow: hidden;
}

.ol-popup--quake {
  border-color: rgba(248, 113, 113, 0.22);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(127, 29, 29, 0.25);
}

.quake-tip {
  padding: 14px;
  text-align: left;
}

.quake-tip__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.quake-tip__eyebrow {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

.quake-tip__mag {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  border: 1px solid transparent;
}

.quake-tip__mag--low {
  background: rgba(34, 197, 94, 0.2);
  border-color: rgba(74, 222, 128, 0.35);
  color: #bbf7d0;
}

.quake-tip__mag--mid {
  background: rgba(234, 179, 8, 0.2);
  border-color: rgba(250, 204, 21, 0.4);
  color: #fef08a;
}

.quake-tip__mag--high {
  background: rgba(220, 38, 38, 0.35);
  border-color: rgba(248, 113, 113, 0.45);
  color: #fecaca;
}

.quake-tip__place {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  color: #f1f5f9;
}

.quake-tip__grid {
  margin: 0;
  padding: 10px 0 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.quake-tip__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin: 0 0 6px;
}

.quake-tip__row:last-child {
  margin-bottom: 0;
}

.quake-tip__row dt {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.quake-tip__row dd {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #cbd5e1;
  text-align: right;
}

.ol-popup__plain {
  padding: 14px;
  white-space: pre-line;
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  color: #cbd5e1;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: rgba(15, 23, 42, 0.96);
  border-width: 9px;
  left: 52px;
  margin-left: -9px;
}

.ol-popup:before {
  border-top-color: rgba(255, 255, 255, 0.12);
  border-width: 10px;
  left: 52px;
  margin-left: -10px;
}

/* OpenLayers: harita gövdesi içinde */
.ol-zoom {
  left: auto !important;
  right: 12px !important;
  top: 10px !important;
}

.ol-zoom button {
  width: 32px;
  height: 32px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  border-radius: 6px;
  background: rgba(15, 23, 42, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #f1f5f9;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.ol-zoom button:hover {
  background: rgba(30, 41, 59, 0.96);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.ol-zoom button:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

/* Ölçek çizgisi */
.ol-scale-line {
  left: 12px !important;
  bottom: 12px !important;
  background: rgba(15, 23, 42, 0.88);
  border-radius: 6px;
  padding: 5px 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.ol-scale-line-inner {
  border-color: rgba(248, 250, 252, 0.85);
  border-width: 2px;
  color: #e2e8f0;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

@media (max-width: 768px) {
  .map-header__bar {
    padding: 6px 8px;
    gap: 6px 8px;
  }

  .map-header__brand {
    font-size: 14px;
  }

  .map-header__meta {
    margin-left: auto;
  }

  .map-header__pinned {
    flex: 1 1 100%;
    max-width: none;
    order: 3;
    gap: 6px;
  }

  .map-header__pinned-row {
    flex: 1 1 auto;
    min-width: 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    padding-bottom: 2px;
  }

  .map-header__pinned-sep {
    display: none;
  }

  .map-header__pin-btn {
    flex: 0 0 auto;
    padding: 5px 8px;
    font-size: 10px;
  }

  .map-header__favorites {
    flex: 1 1 100%;
    max-width: none;
    order: 4;
  }

  .map-header__nav {
    flex: 1 1 100%;
    justify-content: flex-start;
    order: 5;
  }

  .map-header__trigger {
    padding: 8px 10px;
    font-size: 11px;
  }

  .map-dropdown {
    max-height: min(50vh, 320px);
    padding: 8px 10px 10px;
    max-width: calc(100vw - 16px);
  }

  .map-dropdown--wide {
    min-width: min(260px, calc(100vw - 16px));
    max-width: calc(100vw - 16px);
  }

  /* Dar ekranda sağa hizalı panel taşmasın */
  .map-header__menu--align-end .map-dropdown {
    left: auto;
    right: 0;
    max-width: min(300px, calc(100vw - 12px));
  }

  .ol-zoom {
    right: 8px !important;
    top: 8px !important;
  }

  .ol-zoom button {
    width: 30px;
    height: 30px;
    font-size: 15px;
  }

  .ol-scale-line {
    left: 8px !important;
    bottom: 8px !important;
    max-width: calc(100vw - 24px);
  }
}

@media (max-width: 380px) {
  .map-header__trigger {
    padding: 7px 8px;
    font-size: 10px;
  }
}
</style>
